import {
  PerformedSearchRequestContext,
  PerformedSearchRequestContextLocation,
} from 'clientState/providers/SearchRequestProvider';
import {
  SemSearchRequest,
  GeoServiceLocation,
  TripType,
} from '../../../../generated/graphql';
import { SemSearchRequestContextType, SemSearchParamsType } from './index';

export const UrlTripTypesMap = {
  O: 'ONE_WAY',
  R: 'ROUND_TRIP',
};

const parseSemLocations = (segment) => ({
  departure: {
    geoNodeId: segment.departure.geoNodeId,
    iata: segment.departure.iata,
  },
  destination: {
    geoNodeId: segment.destination.geoNodeId,
    iata: segment.destination.iata,
  },
});

export const buildSemSearchRequest = (
  semSearchRequestContextType: SemSearchRequestContextType | null
): SemSearchRequest | null => {
  if (
    semSearchRequestContextType?.itinerary != null &&
    semSearchRequestContextType?.tripType != null
  ) {
    return {
      tripType: semSearchRequestContextType.tripType as TripType,
      itinerary: {
        segments:
          semSearchRequestContextType.itinerary.segments.map(parseSemLocations),
      },
    };
  } else {
    return null;
  }
};

// All the || undefined are to narrow down the null types
// from the Maybe in GraphQL types
const parseLocationRequest = (
  location: GeoServiceLocation
): PerformedSearchRequestContextLocation => ({
  ...location,
  geoNodeType: location.geoNodeType || undefined,
  countryCode: location.countryCode || undefined,
  continent: location.continent || undefined,
  coordinates: location.coordinates || undefined,
  country: location.countryName || undefined,
  city: location.cityName || undefined,
  geoNodeId: location.cityGeoNodeId || undefined,
  iata: location.iataCode || undefined,
  cityIata: location.iataCode || undefined,
  cityName: location.cityName || undefined,
});

export const parseSemSearchParams = (
  semSearchParamsObject: SemSearchParamsType
): PerformedSearchRequestContext => ({
  buyPath: 98,
  tripType: UrlTripTypesMap[semSearchParamsObject.tripType],
  itinerary: {
    numAdults: semSearchParamsObject.adults || 1,
    numChildren: semSearchParamsObject.children || 0,
    numInfants: semSearchParamsObject.infants || 0,
    cabinClass: 'TOURIST',
    mainAirportsOnly: false,
    segments: [
      {
        date: '',
        departure: parseLocationRequest(semSearchParamsObject.from),
        destination: parseLocationRequest(semSearchParamsObject.to),
      },
      {
        date: '',
        departure: parseLocationRequest(semSearchParamsObject.to),
        destination: parseLocationRequest(semSearchParamsObject.from),
      },
    ],
  },
});
